module.exports = __webpack_public_path__ + "img/page.5951fcf4.png";